import React from 'react';

const Footer = () => {
  return (
    <div className="w-full text-center p-5">
      <p className="text-gray-500 dark:text-gray-300">
        Made with ❤️ by <a className="underline" href="https://twitter.com/AlexTypesAlot" target="_blank" rel="noreferrer">Alex Mold</a>
      </p>
    </div>
  );
}

export default Footer;
